import {React} from 'react';
import FormComponent from '../../utils/FormComponent';
import * as blockUtils from '../../../utils/BlockUtils';
import * as api from '../../../api/site-management-api';
import i18next from 'i18next';
import * as viewUtils from '../../../utils/view-utils';
import ModalDialog from '../../utils/ModalDialog';
import ReduxDataTable from '../../redux_data_table/ReduxDataTable';
import PropTypes from 'prop-types';
import SimplifiedCheckbox from '../../utils/SimplifiedCheckbox';

class SiteAccessForm extends FormComponent {
  constructor(props) {
    super(props);

    this.getSites = this.getSites.bind(this);
    this.updateSiteAccess = this.updateSiteAccess.bind(this);

    this.pageNumber = 0;
    this.elementsCount = 10;
    this.sortingName = 'id';
    this.sortingType = 'ASC';
    this.searchPhrase = '';
  }

  initialState() {
    return {
      sites: [],
      user: this.props.user,
      totalElements: 0,
      totalPages: 0,
      dialogId: this.props.dialogId,
      showChangesAppliedPrompt: false,
      onCloseClick: this.props.onCloseClick,
    };
  }

  componentDidMount() {
    this.getSites();
  }

  getSites(
      pageNumber = this.pageNumber,
      elementsCount = this.elementsCount,
      sortingName = this.sortingName,
      sortingType = this.sortingType,
      searchPhrase = this.searchPhrase,
  ) {
    const data = {
      page: pageNumber,
      size: elementsCount,
      query: searchPhrase,
      sort: `${sortingName},${sortingType.toLowerCase()}`,
    };

    blockUtils.blockUI();
    api.getAvailableSitesForUser(this.state.user.id, data).then((response) => {
      const sites = response.data.content;

      blockUtils.unblockUI();
      this.setState({
        sites: sites,
        totalElements: response.data.totalElements,
        totalPages: response.data.totalPages,
      });
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  updateSiteAccess(updatedSite) {
    const oldSite = this.state.sites.find((site) => site.id === updatedSite.id);
    oldSite.selectedByUser = !oldSite.selectedByUser;

    const sites = this.state.sites.map((site) => site.id === oldSite.id ? oldSite : site);
    this.setState({sites: sites});

    const data = {
      siteId: oldSite.id,
      selectedByUser: oldSite.selectedByUser,
    };

    blockUtils.blockUI();
    api.updateSiteAccessForUser(this.props.user.id, data).then((response) => {
      blockUtils.unblockUI();

      if (response.status !== 202) {
        window.showAlert(i18next.t('error'), response.statusText);
        return;
      }

      this.showChangesAppliedPrompt();
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  showChangesAppliedPrompt() {
    this.setState({showChangesAppliedPrompt: true});

    setTimeout(() => {
      this.setState({showChangesAppliedPrompt: false});
    }, 2000);
  }

  render() {
    let title = i18next.t('sites.site_management.user_site_title', {name: this.state.user.username});
    title = title.replace('amp;', '');

    return (
      <ModalDialog
        customClass="site-management-form"
        modalTitle={title}
        dialogId={this.state.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        onCloseClick={this.props.onCloseClick}
        onSubmit={this.updateSiteAccess}
        showSave={false}
        showChangesAppliedPrompt={this.state.showChangesAppliedPrompt}
      >

        <div className="table-container">
          <ReduxDataTable
            {...this.state}
            tableId={'site-management-form-table'}
            getData={this.getSites}
            notSortable={[3, 4]}
          >
            <thead>
              <tr role="row" className="odd heading">
                <th data-sort="id">ID</th>
                <th data-sort="name">{i18next.t('sites.attrs.name')}</th>
                <th>{i18next.t('sites.site_management.attrs.access')}</th>
              </tr>
            </thead>
            <tbody>
              {this.state.sites.map((site) => {
                return (
                  <tr key={site.id}>
                    <td>{site.id}</td>
                    <td>{site.name}</td>
                    <td>
                      <SimplifiedCheckbox
                        fieldId={site.id + ''}
                        value={site.selectedByUser}
                        onChange={() => this.updateSiteAccess(site)}
                        styling={{margin: '5px'}}
                      />
                    </td>
                  </tr>);
              })}
            </tbody>
          </ReduxDataTable>
        </div>
      </ModalDialog>
    );
  }
}

SiteAccessForm.propTypes = {
  user: PropTypes.object,
  dialogId: PropTypes.string,
  onCloseClick: PropTypes.func,
};

export default SiteAccessForm;
